import { TOUR_SPOTS } from "./demoConfig";

/**
 * 演示模式
 * hold: 本幕后停留毫秒（不含飞行时间）
 * fly: TOUR_SPOTS 的 key
 * layers / effects: 显式开关（未写的保持现状）
 * effectsOnly: 若提供，则只打开这些特效、关闭其余（道路飞线 roadLine 始终强制开启）
 * layersOnly: 若提供，则只打开这些图层、关闭其余
 */
export const DEMO_SCRIPT = {
  name: "银川城市一张图 · 标准演示",
  loop: false,
  steps: [
    {
      id: "open",
      title: "开场总览",
      caption: "银川智慧城市 · 三维态势演示",
      hold: 4500,
      fly: "overview",
      layersOnly: [
        "landuse",
        "water",
        "waterway",
        "roads",
        "railway",
        "buildings",
      ],
      effectsOnly: [],
    },
    {
      id: "city",
      title: "核心城区",
      caption: "以光锥为中心 · 光锥与光墙点亮城区",
      hold: 5000,
      fly: "core",
      layersOnly: [
        "landuse",
        "water",
        "waterway",
        "roads",
        "railway",
        "buildings",
      ],
      effectsOnly: ["cone", "wall"],
    },
    {
      id: "fx",
      title: "科技特效",
      caption: "光锥 · 飞线 · 光墙 · 粒子 —— 城市脉搏可视化",
      hold: 6500,
      fly: "cone",
      effectsOnly: [
        "cone",
        "fly",
        "roadLine",
        "radar",
        "spread",
        "wall",
        "particle",
      ],
    },
    {
      id: "traffic",
      title: "交通枢纽",
      caption: "银川站 · 铁路轨道与路网流光",
      hold: 5500,
      fly: "station",
      layersOnly: ["roads", "railway", "buildings"],
      effectsOnly: ["roadLine", "fly"],
    },
    {
      id: "oldtown",
      title: "兴庆老城",
      caption: "历史城区肌理 · 道路与水系交织",
      hold: 5500,
      fly: "oldtown",
      layersOnly: ["roads", "waterway", "water", "buildings"],
      effectsOnly: ["radar", "wall"],
    },
    {
      id: "huabo",
      title: "银川市花博园",
      caption: "花卉博览园 · 水域生态与城市绿心",
      hold: 5500,
      fly: "huabo",
      layersOnly: ["water", "waterway", "landuse", "roads"],
      effectsOnly: ["spread", "particle"],
    },
    {
      id: "finale",
      title: "全域收束",
      caption: "银川 · 感知城市 · 智慧未来",
      hold: 6000,
      fly: "overview",
      layersOnly: ["roads", "buildings", "water", "railway"],
      effectsOnly: ["cone", "radar", "spread", "roadLine"],
    },
  ],
};

export function getSpotByKey(key) {
  return TOUR_SPOTS.find((s) => s.key === key) ?? null;
}

/** 估算整场时长（秒，含飞行约 2.5s/幕） */
export function estimateScriptDuration(script = DEMO_SCRIPT) {
  const flyExtra = 2500;
  const ms = script.steps.reduce((sum, s) => sum + (s.hold || 4000) + flyExtra, 0);
  return Math.round(ms / 1000);
}
